var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"util-action"},[_c('button',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('span',[_vm._v("Batal")])]),_c('button',{staticClass:"primary",on:{"click":function($event){return _vm.$emit('submit')}}},[_c('span',[_vm._v("Simpan")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }